import React, { useEffect, useState } from 'react';
import { useDebounce } from '../../hooks/use-debounce.hook';
import { DateInputComponent } from '../components/date-input.component';
import moment from 'moment';
let isOnChangeTriggered = false;
export function DateInputContainer ({ isDateTimePicker, disablePast, icon, type, name, label, value, onValueChange, placeholder, isDisabled, isRequired }: any) {
  const [
    inputValue,
    setInputValue
  ] = useState(value);
  const debouncedInputValue = useDebounce(
    inputValue,
    500
  );

  useEffect(
    () => {
      if (debouncedInputValue && inputValue && debouncedInputValue === inputValue && isOnChangeTriggered) {
        isOnChangeTriggered = false;
        onValueChange({
          persist: () => {},
          target: {
            type: 'change',
            name,
            value: debouncedInputValue,
          },
        });
      }
    },
    [debouncedInputValue]
  )
  useEffect(
    	      () => {
    	        setInputValue(value)
    	      },
    	      [value]
    	    )

  return (<DateInputComponent
      icon={icon}
      isDisabled={isDisabled}
      isRequired={isRequired}
      isDateTimePicker={isDateTimePicker}
      disablePast={disablePast}
      label={label}
      name={name}
      onValueChange={
        (event: any) => {
          isOnChangeTriggered = true;
          setInputValue(moment(event))
        }
      }
      placeholder={placeholder}
      type={type}
      value={inputValue}
          />)
}
